module.exports = __webpack_public_path__ + "static/media/add-decision-calendar.57d88a1f.svg";